const STORAGE_KEY = "seff_print_previews";

const readMap = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (err) {
    return {};
  }
};

const writeMap = (map) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (err) {
    /* ignore storage errors */
  }
};

export const savePrintPreview = (printRequestId, dataUrl) => {
  if (!printRequestId || !dataUrl) return;
  const map = readMap();
  map[printRequestId] = dataUrl;
  writeMap(map);
};

export const getPrintPreview = (printRequestId) => {
  if (!printRequestId) return "";
  const map = readMap();
  return map[printRequestId] || "";
};
